/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'
import axiosFiles from '../../http/axiosFiles/index.js'

const FormData = require('form-data')

export default {
  addCaso ({ commit }, item) {

    console.log('item', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/setRequest', { request: item }, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then(response => {
          console.log('addCaso ', response.data)

          if (response.data.nuOK === 0) {
            //item.id = response.data.id
            //commit('ADD_CASO', item)
            resolve(response.data.request)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addFilesCaso ({ commit }, item) {

    console.log('addFilesCaso item', item)

    return new Promise((resolve, reject) => {

      const formData = new FormData()
      formData.append('file', item.files)
      formData.append('fileName', item.files.name)
      formData.append('idCaso', item.idCaso)
      formData.append('idUser', item.idUser)
      formData.append('email', 'adminrequest@arquitecsoft.com')

      axiosFiles
        .post('/cargarArchivo', formData, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'multipart/form-data'
          }
        })
        .then(response => {
          console.log('addFilesCaso ', response.data)

          if (response.data.nuOK === 0) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createFileCaso ({ commit }, item) {

    console.log('createFileCaso item', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/createFileCaso',
          item,
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('createFileCaso ', response.data)

          if (response.data.nuOK === 0) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCasoById ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/caso/byid',
          {
            id: item.id,
            idUser: item.idUser
          },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('getCasoById response,', response.data)

          if (response.data.nuOK === 0) {
            const caso = response.data.request
            if (caso.id !== 0) {
              commit('SET_CASO_BY_ID', caso)
              resolve(caso)
            }
            reject(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setCasoById ({ commit }, item) {
    commit('SET_CASO_BY_ID', item)
  },
  getAllCasosByStatePag ({ commit }, item) {
    //console.log('getAllCasosByStatePag request, ', {item})
    return new Promise((resolve, reject) => {
      axios
        .post('/getRequestUsuarioFullByState_Pag',
          {
            usuario: item.id,
            estado: item.state.toUpperCase(),
            filtro: item.filter,
            pageNumber: item.pageNumber,
            pageSize: item.pageSize
          },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Casos ', response.data)
          //console.log('Casos length', response.data.lista.length)

          if (response.data.nuOK === 0) {
            const lista = response.data.lista ? response.data.lista : []
            commit('SET_CASO', lista)
            commit('SET_TOTAL_CASOS', response.data.totalLista || 0)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllCasos ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getRequestUsuarioFull',
          { usuario: item.id },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('Casos ', response.data)
          console.log('Casos length', response.data.lista.length)

          if (response.data.nuOK === 0) {
            const lista = response.data.lista ? response.data.lista : []
            commit('SET_CASO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllCasosCerrados ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getRequestCerradosUsuarioFull',
          { usuario: item.id },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Casos ', response.data)

          if (response.data.nuOK === 0) {
            const lista = response.data.lista ? response.data.lista : []
            commit('SET_CASO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/updateRequest', { request: item })
        .then(response => {
          if (response.data.nuOK === 0) {
            commit('UPDATE_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeCaso ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/caso/delete',
          { id: itemId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
          }
        )
        .then(response => {
          if (response.data.nuOK === 0) {
            commit('REMOVE_CASO', itemId)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  procesarCaso ({ commit }, item) {
    console.log('procesarCaso item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/procesarCaso', item, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          console.log('procesarCaso response,', response.data)
          if (response.data.nuOK === 0) {
            commit('UPDATE_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  pausarCasoByUser ({ commit }, item) {
    console.log('pausarByUser item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/pausarByUser', item, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          console.log('pausarByUser response,', response.data)
          if (response.data.nuOK === 0) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log('pausarByUser error,', error)
          reject(error)
        })
    })
  },
  cerrarCasoByUser ({ commit }, item) {
    console.log('cerrarCaso item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/cerrarCaso', item, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          console.log('cerrarCaso response,', response.data)
          if (response.data.nuOK === 0) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log('cerrarCaso error,', error)
          reject(error)
        })
    })
  },
  devolverInformacionCaso ({ commit }, item) {
    console.log('devolverInformacionCaso item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/devolverInformacionCaso',
          {
            idRequest: item.idRequest,
            idUser: item.idUser,
            observation: item.observation
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('devolverInformacionCaso response,', response.data)

          if (response.data.nuOK === 0) {
            commit('DEVOLVER_INFORMACION_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  apruebaCierreCaso ({ commit }, item) {
    console.log('apruebaCierreCaso item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/apruebaCierreCaso',
          {
            idRequest: item.idRequest,
            idUser: item.idUser,
            observation: item.observation,
            aprobado: item.aprobado
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('apruebaCierreCaso response,', response.data)

          if (response.data.nuOK === 0) {
            commit('APRUEBA_CIERRE_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  escalarUsuarioCaso ({ commit }, item) {
    console.log('escalarUsuarioCaso item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/escalarUsuarioCaso',
          {
            idUser: item.idUser,
            idUserNew: item.idUserNew,
            observation: item.observation,
            idRequest: item.idRequest
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('escalarUsuarioCaso response,', response.data)

          if (response.data.nuOK === 0) {
            commit('ESCALAR_USUARIO_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  escalarServicioCaso ({ commit }, item) {
    console.log('escalarServicioCaso item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/escalarServicioCaso',
          {
            idUser: item.idUser,
            idServiceRequestTypeNew: item.idServiceRequestTypeNew,
            observation: item.observation,
            idRequest: item.idRequest
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('escalarServicioCaso response,', response.data)

          if (response.data.nuOK === 0) {
            //commit('ESCALAR_SERVICIO_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  cambiarCriticidadCaso ({ commit }, item) {
    console.log('cambiarCriticidadCaso item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/cambiarCriticidadCaso',
          {
            idUser: item.idUser,
            idRequestTypeCriticality: item.idRequestTypeCriticality,
            observation: item.observation,
            idRequest: item.idRequest
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('cambiarCriticidadCaso response,', response.data)

          if (response.data.nuOK === 0) {
            //commit('ESCALAR_SERVICIO_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  devolverCasoUsuario ({ commit }, item) {
    console.log('devolverCasoUsuario item,', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/devolverCasoUsuario',
          {
            idUser: item.idUser,
            observation: item.observation,
            idRequest: item.idRequest
          }, {
            headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('devolverCasoUsuario response,', response.data)

          if (response.data.nuOK === 0) {
            //commit('ESCALAR_SERVICIO_CASO', response.data)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
